import { APP_INITIALIZER, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { InvoicesModule } from './invoices/invoices.module';
import { environment } from '../environments/environment';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { HttpInterceptorService } from './services/http-interceptor.service';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { NgbdSortableHeader } from './sortable.directive';
import { SpinnerInterceptor } from './services/spinner.interceptor';
import { ValidateTokenService } from './services/validate-token.service';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ErrorPopupComponent } from './shared/popup/error-popup/error-popup.component';
import { HistoricalPaySummaryComponent } from './historical-data/historical-pay-summary/historical-pay-summary.component';
import { MobileNotSupportedComponent } from './shared/mobile-not-supported/mobile-not-supported.component';

@NgModule({
  declarations: [
    // NgbdSortableHeader,
    HomeComponent,
    AppComponent,
    SidebarComponent,
    ErrorPopupComponent,
    HistoricalPaySummaryComponent,
    MobileNotSupportedComponent
  ],
  imports: [
    NgxSpinnerModule,
    BrowserModule,
    InvoicesModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
    {

      provide: HTTP_INTERCEPTORS,

      useClass: SpinnerInterceptor,

      multi: true,

    },
    TranslateService,
    ValidateTokenService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
